export const backgroundColor = state => state.login.appColors.split(';')[1]